export default "__VITE_ASSET__d1f1828b__"